declare global {
	interface Window {
		Accept: () => void;
	}
}

function createPaymentAsync(data: any, Accept: any) {
	// setTime
	return new Promise(resolve => {
		Accept.dispatchData(data, resolve);
	});
	// setTimeout(() => {

	// 		}, 4000);
}

export const sendPaymentDataToAnet = (cardNumber: string, expiry: string, code: string, Accept: any) => {
	const authData: any = {};
	authData.clientKey = process.env.REACT_APP_CLIENT_KEY;
	authData.apiLoginID = process.env.REACT_APP_LOGIN_KEY;

	const cardData: any = {};
	cardData.cardNumber = cardNumber;
	cardData.month = expiry.substring(0, 2);
	cardData.year = expiry.substring(2, 5);
	cardData.cardCode = code;

	const secureData: any = {};
	secureData.authData = authData;
	secureData.cardData = cardData;

	return secureData;
};
export const createPayment = (data: any, Accept: any, setAuthorizeError: any, setLoading: any) => {
	return createPaymentAsync(data, Accept).then((response: any) => {
		// eslint-disable-next-line no-console
		console.log(response);
		if (response.messages.resultCode === 'Error') {
			response.messages.message.map((message: any) => setAuthorizeError(message.text));
			setLoading(false);
			// eslint-disable-next-line no-console
			console.log('Error', response.messages.message.text, response.messages.message);
		}

		/* send payment result to our backend */

		if (response.messages.resultCode === 'Ok') {
			return response.opaqueData;
		}
	});
};
